module.exports = __webpack_public_path__ + "media/images/emblems/Mathod-coat_of_arms-ae7822a1248dac2705fe7c0e9ad9728e.svg";